module.exports = __webpack_public_path__ + "static/media/Egresos.1c34c9f2.svg";